module.exports = __webpack_public_path__ + "assets/stores-102d97.svg";